import api from '../utils/api';

export type ResumeTokenResponse = {
    accountId: string;
    stage: string;
    nextPath: string;
    email: string | null;
    phone: string | null;
    docNumber: string | null;
    docType: number | null;
    emailVerified: boolean;
    phoneVerified: boolean;
    imageVerified: boolean;
    agreementVerified: boolean;
};

export function consumeResumeToken(token: string): Promise<ResumeTokenResponse> {
    return api.post('/reminder/resume', { token }) as Promise<ResumeTokenResponse>;
}
